import React, { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { api, formatApiError } from "@/lib/api";
import { cn } from "@/lib/utils";

const ts = (s) => (s ? new Date(s).toLocaleString("en-IN") : "-");

function LogTable({ head, rows, empty, testId }) {
  return (
    <div className="overflow-x-auto rounded-xl border border-border bg-card" data-testid={testId}>
      <Table>
        <TableHeader><TableRow className="hover:bg-transparent">{head.map((h) => <TableHead key={h}>{h}</TableHead>)}</TableRow></TableHeader>
        <TableBody>
          {rows.length === 0 && <TableRow><TableCell colSpan={head.length} className="text-center text-muted-foreground">{empty}</TableCell></TableRow>}
          {rows.map((r, i) => <TableRow key={i}>{r.map((c, j) => <TableCell key={j} className="text-sm">{c}</TableCell>)}</TableRow>)}
        </TableBody>
      </Table>
    </div>
  );
}

const EV = { success: "text-emerald-500", failed: "text-rose-500", logout: "text-muted-foreground" };

export function LoginHistory({ userId }) {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/login-history", { params: { user_id: userId } }).then(({ data }) => setRows(data)).catch(() => {}); }, [userId]);
  return <LogTable testId="login-history-table" head={["Time", "Event", "User", "Login ID / Email", "Role", "IP", "Reason"]} empty="No login events yet"
    rows={rows.map((r) => [ts(r.at), <span key="e" className={cn("font-semibold capitalize", EV[r.event])}>{r.event}</span>, r.name || "-", r.identifier, r.role || "-", r.ip, r.reason || "-"])} />;
}

export function ActivityLog({ userId }) {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/activity", { params: { user_id: userId } }).then(({ data }) => setRows(data)).catch(() => {}); }, [userId]);
  return <LogTable testId="activity-table" head={["Time", "User", "Role", "Action", "Target", "Status", "IP"]} empty="No activity yet"
    rows={rows.map((r) => [ts(r.at), r.name, r.role, <span key="a" className={cn("font-medium", r.action === "Access denied" && "text-rose-500")}>{r.action}</span>,
      <span key="p" className="font-mono text-[11px]">{r.method} {r.path}</span>, r.status, r.ip])} />;
}

export function SessionsPanel({ userId }) {
  const [rows, setRows] = useState([]);
  const load = useCallback(() => api.get("/admin/sessions", { params: { user_id: userId } }).then(({ data }) => setRows(data)).catch(() => {}), [userId]);
  useEffect(() => { load(); }, [load]);
  const revoke = async (id) => {
    try { await api.post(`/admin/sessions/${id}/revoke`); toast.success("Session revoked"); load(); }
    catch (e) { toast.error(formatApiError(e?.response?.data?.detail)); }
  };
  return <LogTable testId="sessions-table" head={["User", "Role", "Signed in", "Expires", "IP", ""]} empty="No active sessions"
    rows={rows.map((s) => [s.name, s.role, ts(s.created_at), ts(s.expires_at), s.ip,
      <Button key="r" size="sm" variant="outline" className="text-rose-500" onClick={() => revoke(s.id)} data-testid={`revoke-session-${s.id}`}>Revoke</Button>])} />;
}
